var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubPillarsComputeContainer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24795_195929)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8556 1.24231C11.435 0.925441 12.1344 0.918982 12.7196 1.2251L22.2211 6.19535V15.9164C22.2211 16.6271 21.8394 17.283 21.2216 17.6343L11.7824 23L2.74547 17.6296C2.14622 17.2735 1.77893 16.628 1.77893 15.9309V6.20598L10.8556 1.24231ZM11.9345 2.7259C11.8509 2.68217 11.751 2.6831 11.6683 2.72836L4.39397 6.70638L11.8007 10.7383L19.5438 6.70637L11.9345 2.7259ZM20.5273 8.10387L12.6387 12.2115V20.5649L20.3845 16.1618C20.4728 16.1116 20.5273 16.0179 20.5273 15.9164V8.10387ZM10.945 20.5321V12.2009L3.47268 8.13331V15.9309C3.47268 16.0305 3.52515 16.1227 3.61075 16.1736L10.945 20.5321Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24795_195929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubPillarsComputeContainer);
export default __webpack_public_path__ + "static/media/sub-pillars-compute-container.af29dbd4bb79aa6db3f55d584f9a93c6.svg";
export { ForwardRef as ReactComponent };